/** Report-specific interval union; existing uncoveredAbsences only returns whole absences. */
export function uncoveredCoverIntervals(start:string|null|undefined,end:string|null|undefined,cover:readonly {status:string;starts_at:string;ends_at:string}[]):[number,number][]|null {
 const from=Date.parse(start??''),until=Date.parse(end??'');
 if(!Number.isFinite(from)||!Number.isFinite(until)||until<=from)return null;
 const spans=cover.filter(c=>c.status==='confirmed').map(c=>[Math.max(from,Date.parse(c.starts_at)),Math.min(until,Date.parse(c.ends_at))] as const).filter(([a,b])=>Number.isFinite(a)&&Number.isFinite(b)&&b>a).sort((a,b)=>a[0]-b[0]);
 const gaps:[number,number][]=[];let cursor=from;
 for(const [a,b] of spans){if(a>cursor)gaps.push([cursor,a]);cursor=Math.max(cursor,b)}
 if(cursor<until)gaps.push([cursor,until]);return gaps;
}
